import React, { useEffect, useState } from 'react'
import { api } from "../constants/api";
import getHeaders from '../utils/getHeaders';

const ContactUs = () => {
    const [contactData, setContactData] = useState<any>(null);
    // Fetch contact data
    const getContactData = async () => {
        try {
            const response = await api(false, '/getContactUs', 'get', {}, { ...getHeaders() });
            
            if (response.data.data && response.data.data.length > 0) {
                // Data exists, set edit mode
                const data = response.data.data[0]; // Assuming first record
                setContactData(data);
            } else {
                // No data, set create mode
                setContactData(null);
            }
        } catch (error: any) {
            console.log(error);
        }
    };

    useEffect(() => {
        getContactData();
    }, []);

    return (
        <div className='contact-us'>
            <div className="contact-us-page">
                <h1>Conatct Us</h1>
                <div className="card">
                    <form className='form-part'>
                        <div>
                            <label htmlFor="email">Email :</label>
                            <input type="text" name="email" value={contactData?.email} disabled style={{width: '100%'}}/>
                        </div>
                        <div>
                            <label htmlFor="number">Number :</label>
                            <input type="text" name='number' value={contactData?.contact} disabled style={{width: '100%'}}/>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ContactUs
